module.exports = __webpack_public_path__ + "img/sponsorL05.19e34cbd.png";